import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiService from '../services/apiService';

const detalleComprobanteService = apiService('/detalle-comprobantes'); // Servicio específico para detalle comprobantes
const comprobanteService = apiService('/comprobantes'); // ✅ para endpoint de movimientos por cuenta (backend)

// Thunks
export const fetchDetalleComprobantes = createAsyncThunk(
  'detalleComprobantes/fetchDetalleComprobantes',
  async (_, { rejectWithValue }) => {
    console.log("Entro a slice..detalles")
    try {
      const response = await detalleComprobanteService.getAll();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching detalle comprobantes');
    }
  }
);

export const fetchDetalleComprobanteById = createAsyncThunk(
  'detalleComprobantes/fetchDetalleComprobanteById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await detalleComprobanteService.get(`/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error fetching detalle comprobante by ID');
    }
  }
);

export const createDetalleComprobante = createAsyncThunk(
  'detalleComprobantes/createDetalleComprobante',
  async (detalleComprobante, { rejectWithValue }) => {
    try {
      const response = await detalleComprobanteService.post('/', detalleComprobante);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error creating detalle comprobante');
    }
  }
);

export const updateDetalleComprobante = createAsyncThunk(
  'detalleComprobantes/updateDetalleComprobante',
  async ({ id, detalleComprobante }, { rejectWithValue }) => {
    try {
      const response = await detalleComprobanteService.put(`/${id}`, detalleComprobante);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error updating detalle comprobante');
    }
  }
);

export const deleteDetalleComprobante = createAsyncThunk(
  'detalleComprobantes/deleteDetalleComprobante',
  async (id, { rejectWithValue }) => {
    try {
      await detalleComprobanteService.delete(`/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error deleting detalle comprobante');
    }
  }
);


export const fetchMovimientosByCuenta = createAsyncThunk(
  'detalleComprobantes/fetchMovimientosByCuenta',
  async ({ codigo_cuenta, fechaIni, fechaFin }, { rejectWithValue }) => {
    try {
      if (!codigo_cuenta) return [];

      const params = new URLSearchParams();
      if (fechaIni) params.append('fechaIni', fechaIni);
      if (fechaFin) params.append('fechaFin', fechaFin);

      const qs = params.toString();

      // ✅ OJO: getAllSome ya pone "/" al inicio, por eso NO ponemos "/" aquí
      const endpoint = `movimientos/${encodeURIComponent(codigo_cuenta)}${qs ? `?${qs}` : ''}`;

      const response = await comprobanteService.getAllSome(endpoint);

      return response || [];
    } catch (error) {
      console.error("Error al obtener movimientos por cuenta:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


// Slice
const detalleComprobanteSlice = createSlice({
  name: 'detalleComprobantes',
  initialState: {
    detalleComprobantes: [],
    currentDetalleComprobante: null,
    status: 'idle',
    error: null,

    // ✅ NUEVO: movimientos por cuenta
    movimientosCuenta: [],
    movimientosStatus: 'idle',
    movimientosError: null,
  },
  reducers: {
    resetStatus: (state) => {
      state.status = 'idle';
      state.error = null;
    },
    // ✅ opcional: para limpiar el modal
    resetMovimientos: (state) => {
      state.movimientosCuenta = [];
      state.movimientosStatus = 'idle';
      state.movimientosError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch all
      .addCase(fetchDetalleComprobantes.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchDetalleComprobantes.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.detalleComprobantes = action.payload;
      })
      .addCase(fetchDetalleComprobantes.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // Fetch by ID
      .addCase(fetchDetalleComprobanteById.fulfilled, (state, action) => {
        state.currentDetalleComprobante = action.payload;
      })

      // Create
      .addCase(createDetalleComprobante.fulfilled, (state, action) => {
        state.detalleComprobantes.push(action.payload);
      })

      // Update
      .addCase(updateDetalleComprobante.fulfilled, (state, action) => {
        const index = state.detalleComprobantes.findIndex(
          (detalle) => detalle.id === action.payload.id
        );
        if (index !== -1) {
          state.detalleComprobantes[index] = action.payload;
        }
      })

      // Delete
      .addCase(deleteDetalleComprobante.fulfilled, (state, action) => {
        state.detalleComprobantes = state.detalleComprobantes.filter(
          (detalle) => detalle.id !== action.payload
        );
      })

      // ✅ Movimientos por cuenta
      .addCase(fetchMovimientosByCuenta.pending, (state) => {
        state.movimientosStatus = 'loading';
        state.movimientosError = null;
      })
      .addCase(fetchMovimientosByCuenta.fulfilled, (state, action) => {
        state.movimientosStatus = 'succeeded';
        state.movimientosCuenta = action.payload || [];
      })
      .addCase(fetchMovimientosByCuenta.rejected, (state, action) => {
        state.movimientosStatus = 'failed';
        state.movimientosError = action.payload;
        state.movimientosCuenta = [];
      });
  },
});

export const { resetStatus, resetMovimientos } = detalleComprobanteSlice.actions;

export default detalleComprobanteSlice.reducer;
